import { Component, OnInit, OnDestroy } from '@angular/core';
import { StreamService } from '../services';
import { takeUntil, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import * as moment from 'moment';

@Component({
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center" style="padding-top: 50px;"><spinner></spinner></div>
        <topic-summary-grid *ngIf="!noTouching" [topics]="topics" emptyMessage="No new topics have been added in the last 30 days.">
        </topic-summary-grid>
    `
})
export class BrowseAllNewTopicsPaneComponent implements OnInit, OnDestroy {
    noTouching = true;
    private cleanupTime = new Subject<void>();
    topics: any[];

    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private streamService: StreamService) {}

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.noTouching = true;
            const baseParams = {
                published: true,
                rows: 1000,
                createdAfterDateTime: moment().subtract(30, 'days').toISOString(),
                sort: 'created',
                sortDirection: 'desc'
            };
            
            const parentUrl = this.route.snapshot.parent.parent.url;
            const catalogId = parentUrl[0].path === 'catalog' ? parentUrl[1].path : undefined; 
            const obs = catalogId ? 
                this.streamService.getCatalogStreams(catalogId, baseParams) : 
                this.streamService.getTenantStreams(Object.assign({ includeCatalogs: false }, baseParams));
            obs
            .pipe(tap(() => this.noTouching = false))
            .subscribe(newTopicsResults => {
                this.topics = newTopicsResults.content;
                if (!this.topics.length) {
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: { isEmpty: 'true' },
                        queryParamsHandling: 'merge'
                    });
                }
            });
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
